import React, { useState } from 'react';
import FieldWrapper from './FieldWrapper';
import BarcodeModal from '../../Editors/BarcodeModal';
import Label from '../../../../components/svg/Label';
import { Rgba, getHexColorString, getOpacityFromRgba } from '../../../../helpers/helpers';
import { ValueChangedForFieldFunc } from '../../../formeditor-types';

export type BarcodeFieldProps = {
  valueUpdated: ValueChangedForFieldFunc;
  id?: string;
  fieldId?: string;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  backgroundColor?: string | Rgba;
  padding?: number;
  editable?: boolean;
  name?: string;
  value?: string;
  fontName?: string;
  fontSize?: number;
  align?: TypeMePlease;
  foregroundColor?: string | Rgba;
};

export default function BarcodeField(props: BarcodeFieldProps) {
  const [modalOpen, setModalOpen] = useState(false);

  const mouseDown = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  let modal = null;

  if (modalOpen) {
    modal = <BarcodeModal name={props.name} value={props.value} valueUpdated={props.valueUpdated} onClose={handleModalClose} />;
  }
  return (
    <FieldWrapper
      onMouseDown={mouseDown}
      x={props.x}
      y={props.y}
      w={props.w}
      h={props.h}
      backgroundColor={props.backgroundColor as Rgba}
      editable={props.editable}
      id={props.id}
      fieldId={props.fieldId}
    >
      <Label
        text={props.value}
        fontName={props.fontName}
        fontSize={props.fontSize}
        width={props.w}
        align={props.align}
        padding={props.padding}
        foregroundColor={getHexColorString(props.foregroundColor as Rgba)}
        foregroundColorOpacity={getOpacityFromRgba(props.foregroundColor as Rgba)}
      />
      {modal}
    </FieldWrapper>
  );
}
